angular.module('jv.rejectCandidate.controller', [])
    .controller('jvRejectCandidateController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','jvHireBroadcastSVC', '$http',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,jvHireBroadcastSVC, $http) {
            $scope.renderJSBasedTinyMce = jQuery.fn.jquery.split('.')[0] === '3';
            var selectDefaultTemplate = function(rejectTemplates){
                angular.forEach(rejectTemplates, function(tpl) {
                    if (tpl['default']) {
                        $scope.rejectTemplates.messageTpl = tpl;
                        $scope.content = tpl.body;
                        $scope.subject = tpl.subject;
                    }
                });
                return rejectTemplates;
            };
            var getCustomMessageTemplate = function(templateId) {
                var params = {
                    replaceTokens: false,
                    sendAnonymously: true
                };
                jvCandidatesService.getCustomMessageTemplate($scope.modalData.appId, templateId, params).then(function(res) {
                    $scope.rejectTemplates.messageTpl = res.data.template;
                    $scope.subject = res.data.template.subject;
                    $scope.content = res.data.template.body;
                });
            };
            $scope.$watch('rejectTo', function(newVal) {
                if(angular.isDefined(newVal) && angular.isDefined($scope.rejectInfo)) {
                    if ($scope.customTemplates.type === 'company') {
                        if (newVal === $scope.agencyCandidate.EId) {
                            $scope.rejectTemplates.templates = selectDefaultTemplate($scope.select2Options.setTemplates($scope.rejectInfo.agencyRejectTemplates));
                        } else if (newVal === $scope.modalData.candidateEId) {
                            $scope.rejectTemplates.templates = selectDefaultTemplate($scope.select2Options.setTemplates($scope.rejectInfo.candidateRejectTemplates));
                        }
                    }
                    else if ($scope.rejectTemplates.customTemplate) {
                        getCustomMessageTemplate($scope.rejectTemplates.customTemplate);
                    }
                }
            });
            $scope.$watch('customTemplates.type', function(val) {
                if ($scope.rejectTemplates) {
                    $scope.rejectTemplates.customTemplate = null;
                }
                $scope.content = '';
                $scope.subject = '';
                if (val === 'company' && $scope.rejectTemplates && $scope.rejectTemplates.templates) {
                    selectDefaultTemplate($scope.rejectTemplates.templates);
                }
            });
            $scope.$watch('rejectTemplates.customTemplate', function(val) {
                if (val) {
                    getCustomMessageTemplate(val);
                } else {
                    if ($scope.rejectTemplates) {
                        $scope.rejectTemplates.customTemplate = null;
                    }
                    $scope.content = '';
                    $scope.subject = '';
                }
            });

            jvHireBroadcastSVC.subscribe('hidingCandidateModals', function() {
                $scope.initData();
                $rootScope.$broadcast('rejectCandidateSuccess', true);
            });
            
            $scope.customTemplates = {
                ajaxSelectConfig: {
                    ajax: {
                        type: 'GET',
                        data: function (term, page) {
                            return {
                                page: page - 1,
                                keywords: term
                            };
                        },
                        results: function(data, page){
                            var pageSize = 10;
                            var more = (page * pageSize) < data.count;
                            return {
                                results: data.userEmailTemplates, more: more
                            };
                        }
                    }
                },
                enabled: properties.personalEmailTemplatesEnabled
            };

            $scope.rejectCandidate = function() {
                var data;
                if ($scope.sendMail) {
                    if ($scope.content === '') {
                        $scope.rejectCandidateForm.content.$setValidity('required', false);
                    }
                } else {
                    $scope.rejectCandidateForm.content.$setValidity('required', true);
                }
                //Do not process if the form is still invalid.
                if ($scope.rejectCandidateForm.$invalid) {
                    return;
                }

                if ($scope.modalData.bulk) {
                    data = {
                        dispositionId: $scope.rejectInfo.selectedDisposition,
                        sendRejectionEmail: $scope.sendMail || false,
                        rejectFromAllApplications : ($scope.rejectAll && (!($scope.modalData.rejectAll))) || false,
                        messageDataItem: {
                            entityIdList: $scope.rejectInfo.validApplicationIds,
                            subject: $scope.subject,
                            content: $scope.rejectCandidateForm.content.$viewValue
                        },
                        moveCandidateEnabled: $scope.modalData.moveCandidateEnabled,
                        destinationJobId: $scope.modalData.destinationJobId,
                        bulk: true
                    };

                    $scope.flags.loading = true;
                } else {
                    //This is the object that is sent to the backend.
                    data = {
                        dispositionId : $scope.rejectInfo.selectedDisposition || false,
                        sendRejectionEmail : $scope.sendMail || false,
                        rejectFromAllApplications : ($scope.rejectAll && (!($scope.modalData.rejectAll))) || false,
                        messageDataItem: {
                            entityIdList: [$scope.modalData.appId],
                            subject : $scope.subject,
                            content : $scope.rejectCandidateForm.content.$viewValue
                        },
                        appId: $scope.modalData.appId,
                        bulk: false,
                        moveCandidateEnabled: $scope.modalData.moveCandidateEnabled,
                        destinationJobId: $scope.modalData.destinationJobId
                        
                    };

                    if($scope.modalData.moveCandidateEnabled){
                         delete data.destinationJobId;
                    }


                    $scope.flags.loading=true;

                    //If its an agency candidate and sending email for reject is selected and the rejection should be sent to the candidate
                    //and agency is cc'ed.. then we send notify candidate to backend and also add candidateEID to the list of bcc. 
                    //We need to change this once we have a new backend contract. 

                    var ccList = [], bccList = [];

                    if($scope.rejectInfo.bccEIds)
                    {
                        angular.forEach($scope.rejectInfo.bccEIds, function(user){
                            bccList.push(user);
                        });
                    }
                    if($scope.rejectInfo.ccEIds)
                    {
                        angular.forEach($scope.rejectInfo.ccEIds, function(user){
                            ccList.push(user);
                        });
                    }
                    if ($scope.sendMail) {
                        if ($scope.agencyCandidate) {
                            if ($scope.rejectTo === $scope.modalData.candidateEId) {
                                bccList.push($scope.modalData.candidateEId);
                                data.notifyCandidate = true;
                            } else {
                                data.notifyCandidate = false;
                            }
                        } else {
                            data.notifyCandidate = true;
                        }
                    } else {
                        data.notifyCandidate = false;
                    }

                    data.messageDataItem.bccList = bccList;
                    data.messageDataItem.ccList = ccList;
                }
                
                // if the rejectLater flag is set, set its flag and the day count
                if ($scope.rejectLater) {
                    data.messageDataItem.scheduleLaterNotification = $scope.rejectLater;
                    data.messageDataItem.scheduleLaterNotificationDays = $scope.rejectLaterDays;
                }
 
                if($scope.CandidateListPage && window.JV.Person){
                    window.JV.Person.Global.grid.showLoadingState();
                }else{
                    $scope.flags.loading = true;
                }
                /*BE expects locale to be sent to determine language for Email header/footer*/
                if($scope.rejectTemplates && $scope.rejectTemplates.messageTpl){
                    data.messageDataItem['locale'] = $scope.rejectTemplates.messageTpl['locale'];
                }
                jvCandidatesService.rejectCandidate(data, function(res) {
                    if($scope.CandidateListPage && window.JV.Person){
                        window.JV.Person.Global.grid.removeLoadingState();
                    }else{
                        $scope.flags.loading = false;
                    }
                    
                    //Let the respective callers handle success and failure scenarios. So we just broadcast an event. 
                    if (res.status === 200 ) {
                        if(res.data && $rootScope.size(res.data.notmoved) > 0){
                            $rootScope.moveModalConfig = true;
                            $rootScope.$broadcast('showDuplicateCandidateModal', false, res.data);
                            $scope.flags.loading = false;
                            return false;
                        }
                        if ($scope.modalData.bulk) {
                            $rootScope.$broadcast('rejectCandidateSuccess', false, $scope.modalData.appIds.length ? true: false);
                        } else {
                            $rootScope.$broadcast('rejectCandidateSuccess', false, true, { moveCandidateEnabled: $scope.modalData.moveCandidateEnabled});
                            if(res.data.isRestrictedWorkflowState){
                                $rootScope.$broadcast('showRestrictedCandidateModal');
                            }
                        }
                    } else {
                        $rootScope.$broadcast('rejectCandidateFailure');
                    }
                    $scope.hideRejectCandidateModal();
                    //if you reject from quickview we need to reload the quickview with the status updated
                    if($scope.quickViewdata){
                        window.JV.Modal.hide();
                        if (parseFloat(jQuery.fn.jquery) > 1.7) {
                            window.jv.modalNew.init($scope.quickViewdata, 'jv-modalDialog', true);
                        } else {
                            window.jv.modal.init($scope.quickViewdata, 'jv-modalDialog', true);
                        }
                    }
                });
            };


            $scope.initData = function() {
                $scope.agencyCandidate = false;
                $scope.content = '';
                $scope.rejectInfo = {
                    selectedDisposition : '',
                    bccEIds: []
                };
                $scope.customTemplates.type = 'company';
                $scope.rejectTemplates = {};
                $scope.subject = '';
                $scope.to = '';
                $scope.submitted = false;
                $scope.rejectAll = false || $scope.modalData.rejectAll;
                $scope.rejectLaterDays = 3;
                $scope.updateDaysLater();
            };

            $scope.massageTemplates = function(rejectTemplates) {
                var templates = [];
                angular.forEach(rejectTemplates, function(tpl) {
                    var template = {
                        id: tpl.EId,
                        body: tpl.body,
                        subject: tpl.subject,
                        text: tpl.title
                    };

                    if (tpl['default']) {
                        $scope.rejectTemplates.messageTpl = template;
                        $scope.content = template.body;
                        $scope.subject = template.subject;
                    }
                    templates.push(template);
                });
                return templates;
            };
            
            $scope.init = function() {
                $scope.initData();
                $scope.flags.loading = true;
                if($scope.modalData.moveCandidateEnabled){
                    $scope.btnModalText = i18n.COMMON_REJECT;
                } else{
                    $scope.btnModalText = i18n.I18N_CANDIDATE_BTN_MOVE_REJECT;
                }
                if ($scope.modalData.bulk) {

                    $scope.CandidateListPage = true;
                    $scope.CandidateDetailsPage = false;
                    var postData = {
                        data: $scope.modalData.appIds,
                        action: 'rejectCandidate'
                    };

                    jvCandidatesService.validateCandidateDetails(postData, function(res) {
                        if (res.status !== 200 || !res.data) {
                            $scope.flags.loading = false;
                            return;
                        }
                        
                        if(res.data.validApplicationIds && res.data.validApplicationIds.length === 0) {
                            var actionValidation = {};
                            actionValidation.show = true;
                            actionValidation.title = i18n.REJECT_CANDIDATES;
                            actionValidation.message = i18n.CANDIDATES_REJECT_PERMISSION_MSG;
                            $rootScope.$emit('actionValidation', actionValidation);
                            return;
                        }

                        angular.extend($scope.rejectInfo, res.data);
                        $scope.rejectInfo.totalApplicationCount = $scope.rejectInfo.validApplicationCount + $scope.rejectInfo.invalidApplicationCount;
                        $scope.rejectInfo.totalAgencyApplicationCount = $scope.rejectInfo.validAgencyApplicationCount + $scope.rejectInfo.invalidAgencyApplicationCount;
                        
                        postData.data = res.data.validApplicationIds;
                        jvCandidatesService.rejectCandidateDetailsBulk({applicationEIds: postData.data},{}, function(res) {
                            $scope.flags.loading = false;

                            if ($scope.CandidateListPage && window.JV.Person) {
                                if (window.JV.Person.quickViewChangeStatus) {
                                    window.JV.Modal.hide();
                                }
                            }
                            
                            if (res.status !== 200 || !res.data) {
                                return;
                            }

                            $scope.rejectTemplates.templates = selectDefaultTemplate($scope.select2Options.setTemplates(res.data.templates));
                            $scope.sendMail = $scope.rejectInfo.sendMail = res.data.rejectionEmailEnabled;
                            $scope.rejectLaterEnabled = res.data.isRejectLaterEnabled;
                            if($scope.modalData.moveCandidateEnabled === false){
                                $scope.sendMail = false;
                            }
                            var dispositionsArray = [];
                            angular.forEach(res.data.candidateDispositions, function(disposition) {
                                disposition.id = disposition.EId;
                                disposition.text = disposition.name;
                                dispositionsArray.push(disposition);
                            });

                            $scope.dispositions = dispositionsArray;
                            $scope.modals.rejectCandidate = true;

                            if ($scope.dispositions.length) {
                                $scope.$watch('rejectInfo.selectedDisposition', function(value) {
                                    if (value === '' || angular.isUndefined(value)) {
                                        $scope.rejectCandidateForm.disposition.$setValidity('select2Invalid', false);
                                    } else {
                                        $scope.rejectCandidateForm.disposition.$setValidity('select2Invalid', true);
                                    }
                                });
                            }

                        });
                        
                    });
                } else {
                    //Unfortunately we have different endpoints for candidate list page and details page.
                    //Currently doing an if-else check. But will sometime in the future try to consolidate this.
                    //Will remove a lot of duplicate code.
                    $scope.CandidateListPage = false;
                    $scope.CandidateDetailsPage = true;
                    jvCandidatesService.rejectCandidateDetails({appId: $scope.modalData.appId}, function(res) {
                        if (res.status !== 200 || !res.data) {
                            //Show error message. its not handled in current code.
                            return;
                        }
                       
                        var interviewType = res.data.interviewType;

                        $scope.flags.loading = false;
                        $scope.rejectInfo = interviewType.workflowElementInfo.metaModel;
                        $scope.agencyCandidate = interviewType.model.agency;

                        if ($scope.agencyCandidate) {
                            $scope.rejectInfo.candidateRejectTemplates = interviewType.model.rejectTemplates || [];
                            $scope.rejectInfo.agencyRejectTemplates = interviewType.model.agencyRejectTemplates || [];
                            $scope.rejectInfo.sendMail = interviewType.model.rejectionEmailEnabled;
                            $scope.rejectTo = interviewType.model.agency.EId;
                            $scope.rejectTemplates.templates = selectDefaultTemplate($scope.select2Options.setTemplates($scope.rejectInfo.agencyRejectTemplates));
                        } else {
                            $scope.rejectInfo.candidateRejectTemplates = interviewType.model.rejectTemplates || [];
                            $scope.rejectInfo.sendMail = interviewType.model.rejectionEmailEnabled && !!$scope.modalData.email;
                            $scope.rejectTemplates.templates = selectDefaultTemplate($scope.select2Options.setTemplates($scope.rejectInfo.candidateRejectTemplates));
                        }

                        var dispositionsArray = [];
                        angular.forEach($scope.rejectInfo.candidateDispositions, function(disposition) {
                            disposition.id = disposition.EId;
                            disposition.text = disposition.name;
                            dispositionsArray.push(disposition);
                        });

                        $scope.dispositions = dispositionsArray;
                        $scope.modals.rejectCandidate = true;
                        $scope.sendMail = $scope.rejectInfo.sendMail;
                        if($scope.modalData.moveCandidateEnabled === false){
                                $scope.sendMail = false;
                        }
                        $scope.rejectLaterEnabled = res.data.interviewType.model.isRejectLaterEnabled;

                        if ($scope.dispositions.length) {
                            $scope.$watch('rejectInfo.selectedDisposition', function(value) {
                                if (value === '' || angular.isUndefined(value)) {
                                    $scope.rejectCandidateForm.disposition.$setValidity('select2Invalid', false);
                                } else {
                                    $scope.rejectCandidateForm.disposition.$setValidity('select2Invalid', true);
                                }
                            });
                        }
                    });

                }
                if(!$scope.appDetails && !$scope.applicationId){
                    $scope.CandidateListPage = true;
                    $scope.CandidateDetailsPage = false;
                }
            };

            jvHireBroadcastSVC.subscribe('showRejectCandidateModalView', function() {
                $scope.init();
            });

            $scope.hideRejectCandidateModal = function() {
                $scope.hideModals();
                $scope.initData();
            };
            
            $scope.updateDaysLater = function() {
                if (Object.keys($scope.rejectCandidateForm.rejectLaterDays.$error).length === 0 && $scope.rejectLaterDays) {
                    var d = $scope.getTodayDateUserTimezone();
                    d.setDate(d.getDate() + $scope.rejectLaterDays);
                    $scope.rejectLaterDate = d;
                }
                else {
                    $scope.rejectLaterDate = '';
                }
            };
        }
]).directive('numericOnly', function() {
    return function(scope, element, attrs) {

        var keyCode = [8,9,37,39,48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,110];
        element.on('keydown', function(event) {
            if($.inArray(event.which,keyCode) === -1) {
                scope.$apply(function(){
                    scope.$eval(attrs.onlyNum);
                    event.preventDefault();
                });
                event.preventDefault();
            }

        });
    };
}).directive('jvMessageTemplate', [function () {
    return {
        require: 'ngModel',
        link: function ($scope, iElm, iAttrs, ngModel) {
            $scope.$watch(iAttrs.ngModel, function (val) {
                $scope.$broadcast('templateChanged', iAttrs.jvMessageTemplate, val);
            });
        }
    };
}]).directive('jvMessageTemplateSelect', ['$parse', function ($parse) {
    return {
        require: 'ngModel',
        link: function ($scope, iElm, iAttrs) {
            var ngModel = $parse(iAttrs.ngModel);
            $scope.$watch(iAttrs.ngModel, function (val) {
                if ($scope.$parent[iAttrs.ngModel] !== val) {
                    $scope.$parent[iAttrs.ngModel] = val;
                }
            });
            $scope.$on('templateChanged', function (e, select, val) {
                var newVal = '';
                if (select !== iAttrs.jvMessageTemplateSelect) {
                    return;
                }
                if (val && val[iAttrs.jvMessageTemplateValue]) {
                    newVal = val[iAttrs.jvMessageTemplateValue];
                }
                ngModel.assign($scope, newVal);
            });
        }
    };
}]);